// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Promo Section Styles */
.promo-section {
  position: relative;
  width: 100%;
  height: 400px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Background */
.promo-section__background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.promo-section__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.promo-section__overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.7) 0%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.6) 100%
  );
  z-index: 2;
}

/* Container */
.promo-section__container {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  text-align: center;
}

/* Content */
.promo-section__content {
  max-width: 800px;
  margin: 0 auto;
}

/* Typography */
.promo-section__title {
  font-size: clamp(32px, 5vw, 56px);
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  animation: fadeInUp 1s ease-out 0.3s both;
}

.promo-section__subtitle {
  font-size: 20px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0 0 30px 0;
  opacity: 0.9;
  animation: fadeInUp 1s ease-out 0.5s both;
}

/* Button */
.promo-section__button {
  display: inline-block;
  background: transparent;
  color: white;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 15px 40px;
  border: 2px solid white;
  transition: all 0.3s ease;
  animation: fadeInUp 1s ease-out 0.7s both;
}

.promo-section__button:hover {
  background: white;
  color: #333;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);
}

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .promo-section {
    height: 300px;
  }

  .promo-section__container {
    padding: 0 20px;
  }

  .promo-section__title {
    font-size: clamp(24px, 7vw, 40px);
    margin-bottom: 12px;
    letter-spacing: 1px;
  }

  .promo-section__subtitle {
    font-size: 16px;
    margin-bottom: 25px;
  }

  .promo-section__button {
    font-size: 14px;
    padding: 12px 25px;
    letter-spacing: 1px;
  }
}

@media (max-width: 480px) {
  .promo-section {
    height: 250px;
  }

  .promo-section__container {
    padding: 0 15px;
  }

  .promo-section__title {
    font-size: clamp(20px, 8vw, 32px);
  }

  .promo-section__subtitle {
    font-size: 14px;
  }

  .promo-section__button {
    font-size: 13px;
    padding: 10px 20px;
  }
}

/* Special styling for seafood theme */
.promo-section--seafood .promo-section__overlay {
  background: linear-gradient(
    135deg,
    rgba(13, 71, 161, 0.8) 0%,
    rgba(25, 118, 210, 0.6) 50%,
    rgba(0, 86, 179, 0.7) 100%
  );
}

.promo-section--seafood .promo-section__button {
  border-color: #4FC3F7;
  color: #4FC3F7;
}

.promo-section--seafood .promo-section__button:hover {
  background: #4FC3F7;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/PromoSection.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA,sCAAsC;AACtC;EACE;;;;;GAKC;AACH;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":["/* Promo Section Styles */\n.promo-section {\n  position: relative;\n  width: 100%;\n  height: 400px;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Background */\n.promo-section__background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.promo-section__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n.promo-section__overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    135deg,\n    rgba(0, 0, 0, 0.7) 0%,\n    rgba(0, 0, 0, 0.4) 50%,\n    rgba(0, 0, 0, 0.6) 100%\n  );\n  z-index: 2;\n}\n\n/* Container */\n.promo-section__container {\n  position: relative;\n  z-index: 3;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 40px;\n  text-align: center;\n}\n\n/* Content */\n.promo-section__content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n/* Typography */\n.promo-section__title {\n  font-size: clamp(32px, 5vw, 56px);\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 15px 0;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  animation: fadeInUp 1s ease-out 0.3s both;\n}\n\n.promo-section__subtitle {\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 1.4;\n  margin: 0 0 30px 0;\n  opacity: 0.9;\n  animation: fadeInUp 1s ease-out 0.5s both;\n}\n\n/* Button */\n.promo-section__button {\n  display: inline-block;\n  background: transparent;\n  color: white;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  padding: 15px 40px;\n  border: 2px solid white;\n  transition: all 0.3s ease;\n  animation: fadeInUp 1s ease-out 0.7s both;\n}\n\n.promo-section__button:hover {\n  background: white;\n  color: #333;\n  text-decoration: none;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);\n}\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .promo-section {\n    height: 300px;\n  }\n\n  .promo-section__container {\n    padding: 0 20px;\n  }\n\n  .promo-section__title {\n    font-size: clamp(24px, 7vw, 40px);\n    margin-bottom: 12px;\n    letter-spacing: 1px;\n  }\n\n  .promo-section__subtitle {\n    font-size: 16px;\n    margin-bottom: 25px;\n  }\n\n  .promo-section__button {\n    font-size: 14px;\n    padding: 12px 25px;\n    letter-spacing: 1px;\n  }\n}\n\n@media (max-width: 480px) {\n  .promo-section {\n    height: 250px;\n  }\n\n  .promo-section__container {\n    padding: 0 15px;\n  }\n\n  .promo-section__title {\n    font-size: clamp(20px, 8vw, 32px);\n  }\n\n  .promo-section__subtitle {\n    font-size: 14px;\n  }\n\n  .promo-section__button {\n    font-size: 13px;\n    padding: 10px 20px;\n  }\n}\n\n/* Special styling for seafood theme */\n.promo-section--seafood .promo-section__overlay {\n  background: linear-gradient(\n    135deg,\n    rgba(13, 71, 161, 0.8) 0%,\n    rgba(25, 118, 210, 0.6) 50%,\n    rgba(0, 86, 179, 0.7) 100%\n  );\n}\n\n.promo-section--seafood .promo-section__button {\n  border-color: #4FC3F7;\n  color: #4FC3F7;\n}\n\n.promo-section--seafood .promo-section__button:hover {\n  background: #4FC3F7;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
